import React from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";

import StatusImg from "../../assets/images/completed_status.svg";

const ConfirmModal = ({ onClose, visible }) => {
  return (
    <StyledModal closable footer={null} visible={visible} onCancel={onClose}>
      <Image src={StatusImg} />
      <TopicConfirm>เปลี่ยนรหัสผ่าน</TopicConfirm>
      <Remark>
        คุณสามารถเข้าใช้งานด้วย
        <br />
        รหัสผ่านใหม่ได้ทันที
      </Remark>
    </StyledModal>
  );
};

export default ConfirmModal;

const TopicConfirm = styled.h5`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #058459;
  margin-bottom: 4px;
`;
const Remark = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
  margin-bottom: 16px;
`;
const StyledModal = styled(Modal)`
  font-family: Noto Sans Thai, Noto Sans;
  .ant-modal-content {
    border-radius: 8px;

    .ant-modal-body {
      padding: 36px 32px;
      text-align: center;
    }
  }
`;
const Image = styled.img`
  margin-bottom: 16px;
  width: 144px;
  height: 144px;
`;
